"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMoveOut = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var mapping_1 = require("./mapping");
var useMoveOut = function (accountId) {
    var _a = (0, kapi_1.useMoveOutQuery)({
        variables: {
            accountId: accountId,
        },
    }), kapiData = _a.data, loading = _a.loading, error = _a.error;
    var data = kapiData ? (0, mapping_1.mapMoveOutQueryKapiToMoveOutCX)(kapiData) : null;
    return {
        loading: loading,
        error: error,
        data: data,
    };
};
exports.useMoveOut = useMoveOut;
